// Stable category order for the blog filter chips.
//
// It lives here, not in `_mock/blog.js`, because the filter bar needs the labels
// on every page load: importing them from the mock file pulled the whole
// generated article catalogue (and faker) into the blog page bundle.

export const BLOG_CATEGORIES = ['Exam Prep', 'Licensing', 'Career Tips', 'Success Stories'];